import React from "react";
import RemoteTable from "../../components/ui/RemoteTable";
import { printFullDate } from "../../utils/time";
import { useLanguage } from "../../context/LanguageContext";

const Subscriptions = () => {
    const { language } = useLanguage();

    const content = {
        columns: {
            sequence: { en: "Sequence", ar: "التسلسل" },
            studentName: { en: "Student Name", ar: "اسم الطالب" },
            courseName: { en: "Course Name", ar: "اسم الكورس" },
            subscriptionMethod: { en: "Subscription Method", ar: "طريقة الاشتراك" },
            price: { en: "Price", ar: "السعر" },
            invoiceNumber: { en: "Invoice Number", ar: "رقم الفاتورة" },
            subscriptionDate: { en: "Subscription Date", ar: "تاريخ الاشتراك" },
            deletedCourse: { en: "-- Course Deleted --", ar: "--تم حذف الكورس--" },
            manualPayment: { en: "Manual Payment", ar: "دفع يدوي" },
            autoPayment: { en: "Automatic Payment", ar: "دفع اوتوماتك" },
        },
    };

    let columns = [
        {
            name: content.columns.sequence[language],
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: content.columns.studentName[language],
            reorder: true,
            selector: (row) => row.user.full_name,
        },
        {
            name: content.columns.courseName[language],
            reorder: true,
            selector: (row) =>
                row.subscriptionable ? (
                    row.subscriptionable.name
                ) : (
                    <div className="text-rose-500">{content.columns.deletedCourse[language]}</div>
                ),
        },
        {
            name: content.columns.subscriptionMethod[language],
            reorder: true,
            selector: (row) =>
                row.is_manual ? (
                    <div className="rounded-md px-2 py-1 bg-yellow-500 text-slate-800">
                        {content.columns.manualPayment[language]}
                    </div>
                ) : (
                    <div className="rounded-md px-2 py-1 bg-cyan-500 text-slate-100">
                        {content.columns.autoPayment[language]}
                    </div>
                ),
            sortable: true,
            sortField: "id",
        },
        {
            name: content.columns.price[language],
            reorder: true,
            selector: (row) => row.price,
            sortable: true,
            sortField: "price",
        },
        {
            name: content.columns.invoiceNumber[language],
            reorder: true,
            selector: (row) => row.invoice_id,
            sortable: true,
            sortField: "invoice_id",
        },
        {
            name: content.columns.subscriptionDate[language],
            reorder: true,
            selector: (row) => row.created_at,
            sortable: true,
            sortField: "id",
            format: (row) => printFullDate(row.created_at, language),
        },
    ];

    return (
        <div>
            <div className="w-full">
                <RemoteTable
                    isAdmin={false}
                    api={`/api/user/subscriptions/paginate`}
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default Subscriptions;
